var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"display-4 mt-5"},[_vm._v("Error 404")]),_vm._v(" "),_c('h1',{staticClass:"display-2 mt-0 mb-5"},[_vm._v("Page not found")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","large":"","color":"primary","to":'/' + _vm.$i18n.locale()}},[_vm._v(_vm._s(_vm.$t('Back')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ac9616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/404.vue
// module id = null
// module chunks = 